import * as R from 'ramda';
import {
  FETCH_CURRENT_ORDER_SUCCESS,
  CHANGE_CURRENT_ORDER,
  FETCH_GOODS_SUCCESS
} from '../actionTypes';

const initialState = {
  order: {
    goods: []
  }
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CURRENT_ORDER_SUCCESS:
      return payload;
    case CHANGE_CURRENT_ORDER:
      return { ...state, order: { ...state.order, ...payload } };
    case FETCH_GOODS_SUCCESS:
      if (!state.order) return state;
      return {
        ...state,
        order: {
          ...state.order,
          goods: R.values(state.order.goods).map(i => ({
            ...i,
            data: payload[i.shopGood]
          }))
        }
      };
    default:
      return state;
  }
};
